import { ChevronDownIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const KeyboardArrowDown = createIcon(ChevronDownIcon, "KeyboardArrowDown");

export default KeyboardArrowDown;
